<template>
  <div id="dashboard-analytics">
    <h3>{{loaded}}</h3>
    <span>Aqui você pode extrair uma tabela ou planilha com o relatório de uso da plataforma dos seus atendentes</span>
    <vs-alert
      active="true"
      class="mb-8 mt-8"
      color="warning"
      title="Aviso"
    >
      Preencha os campos abaixo para extrair um relatório
    </vs-alert>
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base">
        <div class="w-12/12">
          <div class="w-full justify-center items-center">
            <span class="phone-number-span mr-12">
            Período (de)
            </span>
          </div>

          <div class="w-full">
            <flat-pickr
              v-model="startAt"
              v-validate="'required'"
              :config="configDateTimePicker"
              name="Período (de)"
              placeholder="Escolha um dia"
            />

            <div class="clear: both;">
              <span v-show="errors.has('Período (de)')" class="text-danger text-sm">
                {{ errors.first('Período (de)') }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base">
        <div class="w-12/12">
          <div class="w-full justify-center items-center">
            <span class="phone-number-span mr-12">
              Período (até)
            </span>
          </div>

          <div class="w-full">
            <flat-pickr
              name="Período (até)"
              v-validate="'required'"
              placeholder="Escolha um dia"
              v-model="finishAt"
              :disabled="startAt === ''"
              :config="finishAtConfig(configDateTimePicker)"
            />

            <div class="clear: both;">
              <span v-show="errors.has('Período (até)')" class="text-danger text-sm">
                {{ errors.first('Período (até)') }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base">
        <div class="w-12/12">
          <div class="w-full justify-center items-center">
            <span class="phone-number-span">Tipo</span>
          </div>

          <v-select
            v-model="type" v-validate="'required'"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            :options="types"
            class="w-full"
            name="Tipo"
          />

          <div class="clear: both;">
            <span v-show="errors.has('Tipo')" class="text-danger text-sm">
             {{ errors.first('Tipo') }}
            </span>
          </div>
        </div>
      </div>

      <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base" v-if="!isReportSmart">
        <div class="w-12/12">
          <div class="w-full justify-center items-center">
            <span class="phone-number-span">&nbsp;</span>
          </div>

          <vs-radio v-model="reportUser" class="mr-2" vs-name="reportUser" vs-value="all">
            Todos Operadores
          </vs-radio>
          <vs-radio v-model="reportUser" vs-name="reportUser" vs-value="specific">
            Operador Específico
          </vs-radio>
        </div>
      </div>
    </div>
    <div v-if="reportUser === 'specific' && !isReportSmart" class="rounded-lg shadow">
      <vs-card>
        <div>
          <users-table :selected-users="selectedUsers" @chooseUser="chooseUser"/>
        </div>
      </vs-card>
    </div>

    <div v-if="type && type.id === 2" class="w-full mb-base">
      <div class="p-2 rounded-lg shadow">
        <tenants-slim-list checkbox :stripe="false" :selecteds="selectedTenants" @selectedTenant="hostnamesChanged" />
      </div>

      <div class="vx-col w-full md:w-1/4 lg:w-1/2 xl:w-1/2 mb-base mt-5">
        <div class="w-12/12">
          <div class="w-full justify-center items-center">
            <span class="phone-number-span">Métricas</span>
          </div>

          <v-select
            v-model="reason" v-validate="'required'"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            :options="reasons"
            class="w-full"
            name="Métrica"
            placeholder="Métricas Inteligentes"
          />

          <div class="clear: both;">
          <span v-show="errors.has('Métrica ')" class="text-danger text-sm">
            {{ errors.first('Métrica ') }}
          </span>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-col w-full">
      <div class="w-12/12">
        <div class="w-full">
          <vs-button class="mt-5 mr-4" color="rgb(0, 205, 216)" @click="generateSheet" v-if="!isReportSmart" :disabled="!type.id">
            Gerar Relatório
          </vs-button>
          <vs-button class="mt-5" @click="exportToExcel" :disabled="!type.id">
            Baixar Relatório
          </vs-button>
        </div>
      </div>
    </div>

    <div id="table-report">
      <div v-if="tableData.length > 0">
        <vs-dropdown class="cursor-pointer mb-4 mr-4 mt-4" vs-trigger-click>
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bgcursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">
              {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{tableData.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableData.length }} de {{ queriedItems }}
            </span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <vs-table
        v-if="typeTable === 1"
        ref="table"
        :data="tableData"
        :max-items="itemsPerPage"
        class="table-report-container mt-4"
        noDataText="Sem dados disponíveis"
        pagination
      >
        <template slot="header">
          <h3 class="mb-3">Relatório: Falhas no Login</h3>
        </template>
        <template slot="thead">
          <vs-th>
            Data
          </vs-th>
          <vs-th>
            Nome do Operador
          </vs-th>
          <vs-th>
            E-mail do Operador
          </vs-th>
          <vs-th>
            Quantidade de Falhas
          </vs-th>
          <vs-th>
            Primeira Falha no Login
          </vs-th>
          <vs-th>
            Útima Falha no Login
          </vs-th>
          <vs-th>
            IP Login
          </vs-th>
          <vs-th>
            IP Logout
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr v-for="dados in data" :key="dados.id">
            <vs-td>
              {{ dados.period }}
            </vs-td>

            <vs-td>
              {{ dados.user.name }}
            </vs-td>

            <vs-td>
              {{ dados.user.email }}
            </vs-td>

            <vs-td>
              {{ dados.failures }}
            </vs-td>

            <vs-td>
              {{ dados.first_failure }}
            </vs-td>

            <vs-td>
              {{ dados.last_failure }}
            </vs-td>

            <vs-td>
              {{ dados.ip_login.ip }}
            </vs-td>

            <vs-td>
              {{ dados.ip_logout.ip }}
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ExcelJS from "exceljs";
import vSelect from 'vue-select'
import {mapGetters} from "vuex";
import 'flatpickr/dist/flatpickr.css';
import flatPickr from 'vue-flatpickr-component'
import reasonHttp from "@/http/requests/reasons";
import {Portuguese} from 'flatpickr/dist/l10n/pt.js'
import UsersTableReport from './UsersTableReport.vue'
import TenantsSlimList from "@/views/Tenants/TenantsSlimList.vue";

export default {
  components: {TenantsSlimList, flatPickr,  vSelect,  'users-table': UsersTableReport },
  data() {
    return {
      page:  1,
      totalPages: 0,
      totalItens: 0,
      itemsPerPage: 100,

      reasons: [],
      tableData: [],
      selectedUsers: [],
      selectedTenants: [],

      type: '',
      startAt: '',
      finishAt: '',
      typeTable: '',
      reportUser: 'all',

      reason: null,
      isMounted: false,
      blockedTime: false,

      configDateTimePicker: {
        enableTime: false,
        noCalendar: false,
        dateFormat: "d/m/Y",
        locale: Portuguese
      }
    }
  },
  computed: {
    ...mapGetters(['token']),
    currentPage() {
      if (this.isMounted) { return this.$refs.table.currentx }
      return 0
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.tableData.length
    },
    isReportSmart(){
      return this.$route.name.includes('dashboard-report-smart') || window.location.pathname.includes('dashboard-report-smart');
    },
    loaded(){
      if (this.isReportSmart) { return 'Métricas Inteligentes'; }
      return 'Métricas de Segurança';
    },
    types(){
      return !this.isReportSmart
      ? [
        {
          id: 1,
          label: 'Falhas no Login'
        }
      ] : [
        {
          id: 2,
          label: 'Métrica Inteligente'
        }
      ];
    }
  },
  watch: {
    isReportSmart(){
      this.clean()
    },
    async type(value) {
      if (!value) { this.type = ''; }
      await this.fetchReasons();
    },
    selectedTenants(value){
      if (value.length > 0) { return this.fetchReasons(); }
      this.clean(false);
    },
    reportUser(reportUser) {
      if (reportUser === 'all') { this.selectedUsers = [] }
    }
  },
  methods: {
    clean(all = true){
      this.page = 1;
      this.totalPages = 0;
      this.totalItens = 0;
      this.startAt = '';
      this.finishAt = '';
      this.reasons = [];
      this.selectedUsers = [];

      if (all){
        this.type = '';
        this.typeTable = '';
        this.reasons = [];
        this.tableData = [];
        this.selectedUsers = [];
        this.selectedTenants = [];
      }
    },
    verify() {
      const permissions = localStorage.getItem('permissions');
      const twoFactor = localStorage.getItem('twoFactor')
      if ( !permissions && !twoFactor ){
        this.$router.push('/user-settings')
      } else if ( !permissions && twoFactor ){
        this.$router.push('/two-factor')
      }
    },
    finishAtConfig(config) {
      return {...config, minDate: this.startAt }
    },
    datePtToEng(date) {
      date = date.split('/')
      return `${date[2]}-${date[1]}-${date[0]}`
    },
    hostnamesChanged(selected){
      this.selectedTenants = selected
    },
    notifyError(title, text) {
      this.$vs.notify({ color: 'danger', title, text })
    },
    notifySuccess(title, text) {
      this.$vs.notify({ color: 'success', title, text })
    },
    chooseUser(userId) {
      const index = this.selectedUsers.indexOf(userId)
      if (index === -1) { this.selectedUsers.push(userId) }
      else { this.selectedUsers.splice(index, 1) }
    },
    async fetchReasons(){
      if (this.selectedTenants.length === 0 || !this.type || this.type.id !== 2){
        return;
      }

      const data = (await reasonHttp.fetch(
        this.token,
        this.selectedTenants,
        '',
        this.page,
        this.itemsPerPage
      ))['data'];

      this.reasons = [];
      this.totalPages = data['total_pages'];
      this.totalItens = data['total_items'];

      data['items'].map(
        item => this.reasons.push({
          id: item.id,
          tenancy_id: item.tenancy_id,
          hostname_id: item.hostname_id,
          tenancy_name: item.tenancy_name.split('.')[0],
          label: `${item.tenancy_name.split('.')[0]} - ${item.description}`
        })
      );
    },
    async downloadXlsx(url, tenantName = null) {
      let reportName = `Relatório`

      if (this.type.id === 2) { reportName += ` Métrica Inteligente - ${this.reason.label}` }

      axios.get(url, {responseType: 'blob'}).then(res => {
        const blob = new Blob([res.data], {type: `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;`});
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = `${reportName}.xlsx`
        link.click()
        window.URL.revokeObjectURL(link.href)
      })
    },
    generateSheet() {
      if (!this.type.id) { return; }

      const startAt = this.datePtToEng(this.startAt)
      const finishAt = this.datePtToEng(this.finishAt)

      if (!this.startAt || !this.finishAt || !this.type) {
        return this.notifyError('Erro ao Gerar Relatório', 'Preencha todos os campos');
      }

      window.scrollTo(0, 0)
      this.$validator.validateAll().then(valid => {
        if (!valid) { return window.scrollTo(0, 0); }

        this.typeTable = this.type.id

        if (this.type.id === 1) {
          this.$store.dispatch('getAllLoginFailuresReport', {startAt, finishAt, selectedUsers: this.selectedUsers}).then(() => {
            const data = Object.values(this.$store.getters.reports || [])

            this.isMounted = true
            this.tableData = data

            if (data.length === 0){ return this.notifyError('Erro', 'Não há dados disponíveis') }
          }).catch(err => console.error(err))
        }
      })
    },
    async exportToExcel() {
      if (!this.type.id) { return; }

      if (this.type.id === 2) {
        window.scrollTo(0, 0);
        this.$validator.validateAll().then(result => {
          if (!this.reason){ return this.notifyError('Nenhuma Métrica selecionada.') }
          if (!result) { return this.notifyError('Revise os dados de filtro.') }

          this.$store.dispatch('getReasons', {
            token: this.token,
            startAt: this.datePtToEng(this.startAt),
            finishAt: this.datePtToEng(this.finishAt),
            tenancyId: this.reason.hostname_id,
            reasonId: this.reason.id
          }).then(res => {
            const {scalar} = res.data
            this.downloadXlsx(scalar, this.reason.tenancy_name)
          }).catch(err => {
            console.error(err.response.data || err)
            this.notifyError('Erro', err.response.data.message)
          })
        })

        return;
      }

      const data = this.$store.getters.reports;
      if (!data || (typeof data !== 'object' || Object.keys(data).length === 0)) {
        return this.notifyError('Erro ao Baixar Relatório', 'Não a Dados para gerar o relatório.')
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Planilha");

      const headers = ["Data", "Nome do Operador", "E-mail do Operador", "Quantidade de Falhas", "Primeira Falha no Login", "Última Falha no Login", "IP Login", "IP Logout"];
      worksheet.addRow(headers);

      if (typeof data === "object") {
        const dataArray = Object.keys(data).map((key) => data[key]);

        dataArray.forEach((row) => {
          const rowData = [row.period, row.user.name, row.user.email, row.failures, row.first_failure, row.last_failure, row.ip_login['ip'], row.ip_logout['ip']];
          worksheet.addRow(rowData);
        });

        const blob = await workbook.xlsx.writeBuffer();
        const blobObject = new Blob([blob], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blobObject);
        const a = document.createElement("a");
        a.href = url;
        a.download = "falhas_login.xlsx";
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      } else {
        console.error("Os dados não estão disponíveis ou não estão no formato esperado.");
      }
    }
  },
  mounted() {
    this.verify()
  }
}
</script>

<style lang="scss">
#table-report {
  width: 100%;
  overflow: auto;

  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

        td {
          padding: 10px;


          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }

          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
          width: 100px;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

.v-select {
  background: #fff;
}

/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right {
      width: 140px;
    }
  }
}

/*! rtl:end:ignore */
</style>

 